import React from "react"
import './CommitteePage.scss'
import { Container, Row } from "react-bootstrap";
import CommitteeCard from "../components/blocks/CommitteeCard";
import JuryCard from "../components/blocks/JuryCard";

function CommitteePage() {

    return (
        <div className="committee-page">
            <div className="up-bg"></div>
            <div className="mid-bg"></div>
            <div className="down1-bg"></div>
            <div className="down2-bg"></div>
            <Container className="position-relative">
                <Row>
                    <h2>
                        {`Состав Международного \nорганизационного комитета`}
                    </h2>
                </Row>

                <div className="cards-container">
                    <CommitteeCard
                        logo={`minpros`}
                        name={`Рассуханов Усман Абдул-Азиевич`}
                        description={`Директор Департамента интеграции национальной системы образования и международного сотрудничества Министерства просвещения Российской Федерации (председатель Международного организационного комитета)`}
                    />
                    <CommitteeCard
                        logo={`cms`}
                        name={`Мерешкин Дмитрий Евгеньевич`}
                        description={`Исполняющий обязанности директора федерального государственного бюджетного образовательного учреждения «Центр международного сотрудничества Министерства просвещения Российской Федерации» (секретарь Международного организационного комитета)`}
                    />

                    <CommitteeCard
                        logo={`sng`}
                        name={`Кобицкий Дмитрий Аркадьевич`}
                        description={`Генеральный секретарь - руководитель Секретариата Совета Межпарламентской ассамблеи государств – участников Содружества Независимых Государств`}
                    />

                    <CommitteeCard
                        logo={`altgpu`}
                        name={`Лазаренко Ирина Рудольфовна`}
                        description={`Ректор федерального государственного бюджетного образовательного учреждения высшего образования «Алтайский государственный педагогический университет»`}
                    />

                    <CommitteeCard
                        logo={`bgpu`}
                        name={`Сагитов Салават Талгатович`}
                        description={`Ректор федерального государственного бюджетного образовательного учреждения высшего образования «Башкирский государственный педагогический университет им. М. Акмуллы»`}
                    />

                    <CommitteeCard
                        logo={`gerzen`}
                        name={`Тарасов Сергей Валентинович`}
                        description={`Ректор федерального государственного бюджетного образовательного учреждения высшего образования «Российский государственный педагогический университет им. А. И. Герцена»`}
                    />

                    <CommitteeCard
                        logo={`asrb`}
                        name={`Бушная Наталия Владимировна`}
                        description={`Сопредседатель Ассоциации школ Российской Федерации и Республики Беларусь`}
                    />
                </div>
            </Container>
            <div className="h-second-bg">
                <Container>
                    <h2 className="h-second">
                        {`Состав жюри и приглашенных экспертов`}
                    </h2>
                </Container>
            </div>
            <div className="card-row card-row-up">
                <Container>
                    <div className="cards-container">
                        <JuryCard
                            type={'jury'}
                            name={`Ануфриева Галина Васильевна`}
                            description={`Доктор филологических наук, доцент кафедры общего и русского языкознания и методики преподавания русского языка как иностранного \nФГБОУ ВО «Алтайский государственный педагогический университет»`}
                        />
                        <JuryCard
                            type={'jury'}
                            name={`Карагодина Инна Андреевна`}
                            description={`Кандидат филологических наук, доцент кафедры общего и русского языкознания и методики преподавания русского языка как иностранного \nФГБОУ ВО «Алтайский государственный педагогический университет»`}
                        />
                        <JuryCard
                            type={'jury'}
                            name={`Зарипова Зульфия Ангамовна`}
                            description={`Консультант проектного офиса, доцент, кандидат педагогических наук \nФГБОУ ВО «Башкирский государственный педагогический университет им. М.Акмуллы»`}
                        />
                        <JuryCard
                            type={'jury'}
                            name={`Шанина Юлия Александровна`}
                            description={`Заведующий кафедрой русской литературы, доцент, кандидат филологических наук \nФГБОУ ВО «Башкирский государственный педагогический университет им. М.Акмуллы»`}
                            last={true}
                        />

                    </div>
                </Container>
            </div>
            <div className="card-row">
                <Container>
                    <div className="cards-container">
                        <JuryCard
                            type={'jury'}
                            name={`Савкина Ирина Георгиевна`}
                            description={`Учитель-методист русского языка и литературы ГУО «Гимназия №1 имени Ф. Скорины г. Минска», лауреат Пушкинской премии`}
                        />
                        <JuryCard
                            type={'expert'}
                            name={`Гаврилова Валентина Леонидовна`}
                            description={`Заведующий кафедрой интенсивного обучения русскому языку как иностранному института русского языка как иностранного, доцент, кандидат филологических наук \nФГБОУ ВО «Российский государственный педагогический университет им. А.И. Герцена»`}
                        />
                        <JuryCard
                            type={'expert'}
                            name={`Жук \nДенис Юрьевич`}
                            description={`Начальник экспертно-аналитического управления Секретариата Совета МПА СНГ`}
                        />
                        <JuryCard
                            type={'expert'}
                            name={`Кулиш Надежда Алексеевна`}
                            description={`Советник отдела внешних связей экспертно-аналитического управления Секретариата Совета МПА СНГ`}
                            last={true}
                        />
                    </div>
                </Container>
            </div>
            <div className="down-el1">
                <Container className="down-el1container">
                    <div className="white-rect w-100"></div>
                </Container>
            </div>
            <div className="down-el2"></div>
        </div>
    );
}

export default CommitteePage;